import { render, staticRenderFns } from "./PhoneOutline.vue?vue&type=template&id=1880659b&"
import script from "./PhoneOutline.vue?vue&type=script&lang=ts&"
export * from "./PhoneOutline.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports